import BannerActions from './components/BannerActions.vue'

export default {
  components: {
    BannerActions,
  },
  data() {
    return {}
  },
}



// WEBPACK FOOTER //
// ./src/templates/components/ui-components/banner/component.js